import VerlagBlack from './Verlag-Black.otf';
import VerlagBlackItalic from './Verlag-BlackItalic.otf';
import VerlagBold from './Verlag-Bold.otf';
import VerlagBoldItalic from './Verlag-BoldItalic.otf';
import VerlagBook from './Verlag-Book.otf';
import VerlagBookItalic from './Verlag-BookItalic.otf';
import VerlagLight from './Verlag-Light.otf';
import VerlagLightItalic from './Verlag-LightItalic.otf';
import VerlagXLight from './Verlag-XLight.otf';
import VerlagXLightItalic from './Verlag-XLightItalic.otf';

export default {
  VerlagBlack,
  VerlagBlackItalic,
  VerlagBold,
  VerlagBoldItalic,
  VerlagBook,
  VerlagBookItalic,
  VerlagLight,
  VerlagLightItalic,
  VerlagXLight,
  VerlagXLightItalic,
};



// WEBPACK FOOTER //
// ./src/fonts/font-files.js